import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { ReactComponent as TrashRed } from '../../../../../assets/icons/trash-red.svg';
import './delete_tx.component.css';

const DeleteTx = (props) => {
  //map props to state
  const { show, setShow, company, onRemoveCompany } = props;

  return (
    <Modal
      show={show}
      centered
      className="delete_instrument__modal"
      onHide={() => setShow(false)}
    >
      <Modal.Body>
        <TrashRed />
        <h5 className="m-0">Delete {company && company.name}</h5>
        <p>
          Are you sure you want to delete{' '}
          <span className="company-name">{company && company.name}</span> from
          your Portfolio?
        </p>
        <div className="btns__cont">
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShow(false)}
          >
            No, Cancel
          </button>
          <button
            type="button"
            className="confirm_btn"
            onClick={onRemoveCompany}
          >
            <span>Yes, Delete</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteTx;
